import { createStore } from "zustand/vanilla";

export type Message = {
  id: string;
  content: string;
  role: "user" | "assistant";
  timestamp: number;
};

export type AidaState = {
  messages: Message[];
  isOpen: boolean;
  isLoading: boolean;
};

export type AidaActions = {
  addMessage: (
    message: Omit<Message, "id" | "timestamp"> & {
      id?: string;
      timestamp?: number;
    },
  ) => void;
  updateMessage: (id: string, content: string) => void;
  clearMessages: () => void;
  toggleChat: () => void;
  setLoading: (isLoading: boolean) => void;
};

export type AidaStore = AidaActions & AidaState;

export const defaultInitState: AidaState = {
  messages: [],
  isOpen: false,
  isLoading: false,
};

export const createAidaStore = (initState: AidaState = defaultInitState) => {
  return createStore<AidaStore>()((set) => ({
    ...initState,
    addMessage: (message) => {
      set((state) => ({
        messages: [
          ...state.messages,
          {
            ...message,
            id: message.id || Date.now().toString(),
            timestamp: message.timestamp || Date.now(),
          },
        ],
      }));
    },
    updateMessage: (id, content) => {
      set((state) => ({
        messages: state.messages.map((msg) =>
          msg.id === id ? { ...msg, content } : msg,
        ),
      }));
    },
    clearMessages: () => {
      set({ messages: [] });
    },
    toggleChat: () => {
      set((state) => ({ isOpen: !state.isOpen }));
    },
    setLoading: (isLoading) => {
      set({ isLoading });
    },
  }));
};
